export const getRootDomain = (url: URL | Location): string => url.host.split('.').slice(1).join('.')

export function isURL(url: string): boolean {
  try {
    new URL(url)
    return true
  } catch (_error) {
    return false
  }
}
